class Native {
    static getStoreId() {
        try {
            if (window?.Shopify?.locale?.length > 1) {
                let storeId = Native.stringToAsciiCodeString(window?.Shopify?.locale);
                return Number(storeId);
            }
            else {
                return null;
            }
        }
        catch (e) {
            console.error({
                msg: 'cannot getStoreId',
                locale: window?.Shopify?.locale
            });
        }
    }
    static getCurrentLanguage() {
        try {
            return (window?.Shopify?.locale) ?? 'en';
        }
        catch (e) {
            console.error({
                msg: 'cannot get language using Shopify'
            });
        }
    }
    static stringToAsciiCodeString(inputString) {
        let asciiCodeString = '';
        for (let i = 0; i < inputString.length; i++) {
            const character = inputString.charAt(i);
            const asciiCode = character.charCodeAt(0);
            // Concatenate the ASCII code to the result string
            asciiCodeString += asciiCode.toString();
            // Add a separator (e.g., a space) unless it's the last character
            if (i < inputString.length - 1) {
                asciiCodeString += '';
            }
        }
        return asciiCodeString.toString();
    }
}
export { Native };
//# sourceMappingURL=Native.js.map